<template>
  <section>
    <div class="row">
      <div
        id="loadingmessage"
        style="
          text-align: center;
          margin: 0px;
          padding: 0px;
          position: fixed;
          right: 0px;
          top: 0px;
          width: 100%;
          height: 100%;
          background-color: white;
          z-index: 30001;
          opacity: 0.8;
        "
        v-if="loading"
      >
        <p style="position: absolute; color: White; top: 40%; left: 40%">
          <img src="../../../assets/snakes.gif" />
        </p>
      </div>
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">
              DETAILS &nbsp;
              <!-- <router-link :to="'/sightingsloc1/'+this.id ">
                <span>
                  <i style="color:red!important" class="fa fa-map-marker"></i>
                </span>
              </router-link>-->
            </h4>
            <div class="row">
              <!-- <div class="col-2">
                <div class="row pl-3">
                  <output class="flex md12">
                    <enlargeable-image
                      v-if="im"
                      v-bind:src="image"
                      v-bind::src_large="image"
                    >
                      <img
                        :src="image"
                        v-if="im"
                        style="width: 100%; height: auto"
                      />
                    </enlargeable-image>
                
                  </output>
                </div>
              </div> -->

              <div class="col-md-7" v-if="data != ''">
                <table class="table table-white flex md12">
                  <thead>
                    <tr>
                      <h5>Report Details</h5>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="col">Description</th>
                      <td>{{ data.reportId.description }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Snake</th>
                      <td v-if="data.reportId.snake != undefined">
                        {{ data.reportId.snake.name }}
                      </td>
                      <td v-else>Not Known</td>
                    </tr>
                    <tr>
                      <th scope="col">Created At</th>
                      <td>{{ data.reportId.createdAt.slice(0, 10) }}</td>
                    </tr>
                     <tr>
                      <th scope="col">Reported By</th>
                      <td v-if="data.reportId && data.reportId.user && data.reportId.user.name">{{data.reportId.user.name}} - {{data.reportId.user.phone}}</td>
                    </tr>
                    <tr>
                      <th scope="col">Situation</th>
                      <td>{{ data.reportId.situation }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Division Name</th>
                      <td v-if="data.division[0]">{{ data.division[0].divisionName }}</td>
                    </tr>
                     <tr>
                      <th scope="col">Status</th>
                      <td><b>{{ data.status }}</b></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-md-5" v-if="data.status == 'Approved'">
                <table class="table table-white flex md12">
                  <thead>
                    <tr>
                      <h5>Approval Details</h5>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="col">                          <v-layout wrap justify-start>
                            <v-flex
                              xs12
                              sm6
                              lg4
                              md6
                              pt-2
                              v-if="data && data.rescuer && data.rescuer.name"
                            >
                              <v-flex xs12 text-left>
                                <span class="itemKey">Rescuer</span>
                              </v-flex>
                              <v-flex xs12 text-left>
                                <span class="itemValue">
                                  {{ data.rescuer.name }} -
                                  {{ data.rescuer.phone }}
                                  <span v-if="!data.rescuer.name">-</span>
                                </span>
                              </v-flex>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              lg4
                              md6
                              pt-2
                              v-if="
                                data && data.rescue && data.rescue.rescuedAt
                              "
                            >
                              <v-flex xs12 text-left>
                                <span class="itemKey">Rescued At</span>
                              </v-flex>
                              <v-flex xs12 text-left>
                                <span class="itemValue">
                                  {{ data.rescue.rescuedAt.slice(0, 10) }}
                                  <span v-if="!data.rescue.rescuedAt">-</span>
                                </span>
                              </v-flex>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              lg4
                              md6
                              pt-2
                              v-if="data && data.rescue && data.rescue.locality"
                            >
                              <v-flex xs12 text-left>
                                <span class="itemKey">Rescued from</span>
                              </v-flex>
                              <v-flex xs12 text-left>
                                <span class="itemValue">
                                  {{ data.rescue.locality }}
                                  <span v-if="!data.rescue.locality">-</span>
                                </span>
                              </v-flex>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              lg4
                              md6
                              pt-2
                              v-if="data && data.rescue"
                            >
                              <v-flex xs12 text-left>
                                <span class="itemKey">Laid Eggs</span>
                              </v-flex>
                              <v-flex xs12 text-left>
                                <span class="itemValue">
                                  <span v-if="data.rescue.laidEggs === true"
                                    >Yes</span
                                  >
                                  <span v-if="data.rescue.laidEggs === false"
                                    >No</span
                                  >
                                </span>
                              </v-flex>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              lg4
                              md6
                              pt-2
                              v-if="data && data.rescue"
                            >
                              <v-flex xs12 text-left>
                                <span class="itemKey">Gravid</span>
                              </v-flex>
                              <v-flex xs12 text-left>
                                <span class="itemValue">
                                  <span v-if="data.rescue.gravid === true"
                                    >Yes</span
                                  >
                                  <span v-if="data.rescue.gravid === false"
                                    >No</span
                                  >
                                </span>
                              </v-flex>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              lg4
                              md6
                              pt-2
                              v-if="data && data.rescue && data.rescue.district"
                            >
                              <v-flex xs12 text-left>
                                <span class="itemKey">District</span>
                              </v-flex>
                              <v-flex xs12 text-left>
                                <span class="itemValue">
                                  {{ data.rescue.district }}
                                  <span v-if="!data.rescue.district">-</span>
                                </span>
                              </v-flex>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              lg4
                              md6
                              pt-2
                              v-if="data && data.rescue && data.rescue.quantity"
                            >
                              <v-flex xs12 text-left>
                                <span class="itemKey">Quantity</span>
                              </v-flex>
                              <v-flex xs12 text-left>
                                <span class="itemValue">
                                  {{ data.rescue.quantity }}
                                  <span v-if="!data.rescue.quantity">-</span>
                                </span>
                              </v-flex>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              lg4
                              md6
                              pt-2
                              v-if="data && data.rescue && data.rescue.sex"
                            >
                              <v-flex xs12 text-left>
                                <span class="itemKey">Sex</span>
                              </v-flex>
                              <v-flex xs12 text-left>
                                <span class="itemValue">
                                  {{ data.rescue.sex }}
                                  <span v-if="!data.rescue.sex">-</span>
                                </span>
                              </v-flex>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              lg4
                              md6
                              pt-2
                              v-if="
                                data && data.rescue && data.rescue.difficulties
                              "
                            >
                              <v-flex xs12 text-left>
                                <span class="itemKey">Rescue Difficulties</span>
                              </v-flex>
                              <v-flex xs12 text-left>
                                <span class="itemValue">
                                  {{ data.rescue.difficulties }}
                                  <span v-if="!data.rescue.difficulties"
                                    >-</span
                                  >
                                </span>
                              </v-flex>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              lg4
                              md6
                              pt-2
                              v-if="
                                data && data.rescue && data.rescue.delayReasons
                              "
                            >
                              <v-flex xs12 text-left>
                                <span class="itemKey">Delay Reasons</span>
                              </v-flex>
                              <v-flex xs12 text-left>
                                <span class="itemValue">
                                  {{ data.rescue.delayReasons }}
                                  <span v-if="!data.rescue.delayReasons"
                                    >-</span
                                  >
                                </span>
                              </v-flex>
                            </v-flex>
                          </v-layout></th>
                      <td v-if="data.approval.remarks != undefined">{{ data.approval.remarks }}</td>
                        <td v-else>Remarks not added</td>
                    </tr>
                  </tbody>
                </table>
              </div>

               <div class="col-md-5" v-if="data.status == 'Closed'">
                <table class="table table-white flex md12">
                  <thead>
                    <tr>
                      <h5>Details</h5>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="col">Remarks</th>
                      <td>{{ data.approval.remarks }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                class="col-md-6"
                v-if="
                  data.status == 'Rescued' ||
                  data.status == 'Released' ||
                  data.status == 'Approved' ||
                  data.status == 'OnReview' ||
                  data.status == 'Closed'
                "
              >
                <br /><br />
                <table class="table table-white flex md12">
                  <thead>
                    <tr>
                      <th scope="col" style="min-width: 150px">
                        <h5>Rescue Details</h5>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="col">Rescued At</th>
                      <td>{{ data.rescue.rescuedAt.slice(0, 10) }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Rescuer</th>
                      <td v-if="data && data.rescuer && data.rescuer.name">{{data.rescuer.name}} - {{data.rescuer.phone}}</td>
                    </tr>
                    <tr>
                      <th scope="col">Rescued from</th>
                      <td>{{ data.rescue.locality }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Laid Eggs</th>
                      <td>{{ data.rescue.laidEggs }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Gravid</th>
                      <td>{{ data.rescue.gravid }}</td>
                    </tr>
                    <tr>
                      <th scope="col">District</th>
                      <td>{{ data.rescue.district }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Quantity</th>
                      <td>{{ data.rescue.quantity }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Sex</th>
                      <td>{{ data.rescue.sex }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Rescue Difficulties</th>
                      <td>{{ data.rescue.difficulties }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Delay Reasons</th>
                      <td>{{ data.rescue.delayReasons }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                class="col-md-6"
                v-if="
                  (data.status == 'Released' ||
                  data.status == 'Approved' ||
                  data.status == 'OnReview') && data.release.type == 'Release'"
              >
                <br /><br />
               <table class="table table-white flex md12">
                  <thead>
                    <tr>
                      <th scope="col" style="min-width:150px;">
                        <h5>Released Details</h5>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="col">Released Date</th>
                      <td>{{data.release.releasedAt.slice(0,10)}}</td>
                    </tr>
                    <tr></tr>
                    <tr>
                      <th scope="col">Released or Not?</th>
                      <td>
                        <p v-if="data.release.releasedOrNot == 'false'">No</p>
                        <p v-else>Yes</p>
                      </td>
                    </tr>
                    <tr>
                      <th scope="col">Released from</th>
                      <td>{{data.release.locality}}</td>
                    </tr>
                    <tr>
                      <th scope="col">Snake Health</th>
                      <td>{{data.release.snakeHealth}}</td>
                    </tr>
                    <tr>
                      <th scope="col">Snake Mishaps</th>
                      <td v-if="data.release.mishaps==false">No Changes</td>
                      <td v-if="data.release.mishaps==true">Yes</td>
                    </tr>
                    <tr>
                      <th scope="col">District</th>
                      <td>{{data.release.district}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                class="col-md-6"
                v-if="
                  (data.status == 'Released' ||
                  data.status == 'Approved' ||
                  data.status == 'OnReview' ||
                  data.status == 'Closed') && data.release.type == 'Handover'"
              >
                <br /><br />
              <table class="table table-white flex md12">
                  <thead>
                    <tr>
                      <th scope="col" style="min-width:150px;">
                        <h5>Released Details</h5>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="col">Released Date</th>
                      <td>{{data.release.releasedAt.slice(0,10)}}</td>
                    </tr>
                    <tr></tr>
                    <tr>
                      <th scope="col">Released or Not?</th>
                      <td>
                        <p v-if="data.release.releasedOrNot == 'false'">No</p>
                        <p v-else>Yes</p>
                      </td>
                    </tr>
                    <tr>
                      <th scope="col">Handovered to</th>
                      <td v-if="data.release.handoverplatform == 'Range'">{{data.release.handoverrange.rangeName}}</td>
                       <td v-if="data.release.handoverplatform == 'Division'"> {{data.release.handoverdivision.divisionName}}</td>
                       <td v-if="data.release.handoverplatform == 'RRT'">{{data.release.handoverrrt.name}}</td>
                    </tr>
                    <tr>
                      <th scope="col">Snake Mishaps</th>
                      <td v-if="data.release.mishaps==false">No Changes</td>
                      <td v-if="data.release.mishaps==true">Yes</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <hr>
                 <div class="col-md-12" v-if="photographs.length > 0">
              <p><b>Reported Images</b></p>
              <div class="images" v-viewer="{movable: false}">
      <img style="
    vertical-align: middle;
    border-style: none;
    width: 10%;
    height: auto;
    padding-left: 10px;padding-bottom:10px;" v-for="src in photographs" :src="src" :key="src">
    </div>
            </div>
     <div class="col-md-12" v-if="rescuedimages.length > 0">
              <p><b>Rescued Images</b></p>
              <div class="images" v-viewer="{movable: false}">
      <img style="
    vertical-align: middle;
    border-style: none;
    width: 10%;
    height: auto;
    padding-left: 10px;padding-bottom:10px;" v-for="src in rescuedimages" :src="src" :key="src">
    </div>
              </div>
               <div class="col-md-12" v-if="releasedimages.length > 0">
              <p><b>Released Images</b></p>
              <div class="images" v-viewer="{movable: false}">
      <img style="
    vertical-align: middle;
    border-style: none;
    width: 10%;
    height: auto;
    padding-left: 10px;padding-bottom:10px;" v-for="src in releasedimages" :src="src" :key="src">
    </div>
              </div>
              <hr>
              <hr>
             <div class="col-md-12">
                <p><b>Map</b></p>
                <div id="map"></div>
              </div>
              
              <div class="col-md-12">
                <br><br>
              <div class="row">
             <div class="col-md-4">
                <button class="btn btn-danger" @click="deleteItem()">Delete Operation</button>
             </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios";
import EnlargeableImage from "@diracleo/vue-enlargeable-image";
var marker;
export default {
  components: {
    EnlargeableImage,
  },
  name: "myprofile",
  props: ["id"],
  data() {
    return {
      image: null,
      name: "",
      data: "",
      userdata: [],
      loading: false,
      im: "",
      idByAdmin: "",
      distance: "",
      remarks: "",
      rescuerCode: "",
      item: [],
      assignedTo: "",
       photographs: [],
       rescuedimages: [],
      releasedimages: []
    };
  },
  mounted: function () {
    this.getview();
  },

  methods: {
    getview() {
      this.loading = true;
      var mapCanvas = document.getElementById("map");
      var vm = this;
      axios({
        method: "GET",
        url: "https://sarpatnapi.leopardtechlabs.in/operation/get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: { id: this.id },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.data = response.data.data;
            var temp1 = response.data.reportedimages;
            for(var j=0;j<temp1.length;j++){
              var ty =  "https://sarpatnapi.leopardtechlabs.in/u/"+temp1[j]
               this.photographs.push(ty);
            }
            var temp2 = response.data.rescuedimages;
            for(var j=0;j<temp2.length;j++){
              var ty1 =  "https://sarpatnapi.leopardtechlabs.in/u/"+temp2[j]
               this.rescuedimages.push(ty1);
            }
            var temp3 = response.data.releasedimages;
            for(var j=0;j<temp3.length;j++){
              var ty2 =  "https://sarpatnapi.leopardtechlabs.in/u/"+temp3[j]
               this.releasedimages.push(ty2);
            }
            this.userdata = response.data.data.user;
            this.im = response.data.data.reportId.pic;
            if (response.data.data.division) {
              if (response.data.data.division.length > 0) {
                this.divisionid = response.data.data.division[0]._id;
                this.division = response.data.data.division;
              }
            }
            if (response.data.data.reportId.pic !== null) {
              this.image =
                "https://sarpatnapi.leopardtechlabs.in/u/" + response.data.data.reportId.pic;
            }
             var mapOptions = {
        // eslint-disable-next-line
        // eslint-disable-next-line
        center: new google.maps.LatLng(response.data.data.reportId.location[1], response.data.data.reportId.location[0]),
        zoom: 10,
        // eslint-disable-next-line
        mapTypeId: google.maps.MapTypeId.HYBRID
      }
        vm.map = new google.maps.Map(mapCanvas, mapOptions)
            var temp = [];
            var ty = {
                lat : response.data.data.reportId.location[0],
                lng : response.data.data.reportId.location[1],
                type: 'Reported Location'
            }
            temp.push (ty);
            if(response.data.data.rescue.location.length > 0){
            var ty1 = {
                lat : response.data.data.rescue.location[0],
                lng : response.data.data.rescue.location[1],
                type: 'Rescued Location'
            }
            temp.push(ty1)
            }
             if(response.data.data.release.location.length > 0){
            var ty1 = {
                lat : response.data.data.release.location[0],
                lng : response.data.data.release.location[1],
                type: 'Released Location'
            }
            temp.push(ty1)
            }
            for(var i=0; i<temp.length;i++){
            var lat = temp[i].lat;
            var lon = temp[i].lng;
            var latlngset = new google.maps.LatLng(lon, lat);
              if(temp[i].type == 'Reported Location'){
            var iconBase = {
              url: "https://sarpatnapi.leopardtechlabs.in/u/map_pink.png", // url
              scaledSize: new google.maps.Size(20, 35), // scaled size
              origin: new google.maps.Point(0, 0), // origin
              anchor: new google.maps.Point(0, 0), // anchor
            };
            }
            if(temp[i].type == 'Rescued Location'){
            var iconBase = {
              url: "https://sarpatnapi.leopardtechlabs.in/u/map_blue.png", // url
              scaledSize: new google.maps.Size(20, 35), // scaled size
              origin: new google.maps.Point(0, 0), // origin
              anchor: new google.maps.Point(0, 0), // anchor
            };
            }
            if(temp[i].type == 'Released Location'){
            var iconBase = {
              url: "https://sarpatnapi.leopardtechlabs.in/u/map_yellow.png", // url
              scaledSize: new google.maps.Size(20, 35), // scaled size
              origin: new google.maps.Point(0, 0), // origin
              anchor: new google.maps.Point(0, 0), // anchor
            };
            }
            // eslint-disable-next-line
            marker = new google.maps.Marker({
              map: vm.map,
              position: latlngset,
              icon: iconBase,
            });
            // vm.oMarker[i] = {
            //   m: marker,
            //   c: id
            // }
            var content = temp[i].type;
            var infowindow = new google.maps.InfoWindow();
            google.maps.event.addListener(
              marker,
              "click",
              (function (marker, content, infowindow) {
                return function () {
                  infowindow.setContent(content);
                  infowindow.open(vm.map, marker);
                };
              })(marker, content, infowindow)
            );
            }
            this.loading = false;
          } else if (response.data.status === false) {
            this.loading = false;
          }
        })
        .catch((err) => {
          this.errors.push(err);
          alert("No Network Found!!");
        });
    },
          deleteItem: function (item) {
        if (confirm("Are you sure?")) {
      var vm = this;
      vm.item = this.id;
      axios({
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        url: "https://sarpatnapi.leopardtechlabs.in/operation/delete",
        data: {
          id: vm.item,
        },
      })
        .then((response) => {
          alert("Operation was successfully Deleted");
           this.$router.push("/approvedList/");
        })
        .catch((e) => {});
          }
    },
  },
};
</script>
<style>
.modal-footer {
  display: none !important;
}
.circular--square {
  border-top-left-radius: 50% 50%;
  border-top-right-radius: 50% 50%;
  border-bottom-right-radius: 50% 50%;
  border-bottom-left-radius: 50% 50%;
}
#map {
  height: 350px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/forms/operation/approvedDetails.vue